export enum USER_ROLES{
    'ADMIN' = 'Admin',
    'LEA' = 'LEA',
    'LEA3rdParty' = 'LEA3rdParty',
    'IHE' = 'IHE',
    'APPLICANT' = 'Applicant',
    'LEA_PA' = 'LEA-PA',
}